import Style from "./style"
import close from "./asset/close.svg"

const DefaultSlideModal = ({ children, title, closeEvent }) => {

    return (
        <Style.ModalBackground>
            <Style.Modal>
                {title &&
                    <Style.TitleDiv>
                        <h2>{title}</h2>
                        <button onClick={closeEvent}><img src={close} /></button>
                    </Style.TitleDiv>
                }
                {children}
            </Style.Modal>
        </Style.ModalBackground>
    )
}

export default DefaultSlideModal